const IsTokenExpired = (decodedToken: any) => {
  if (!decodedToken || !decodedToken.exp) {
    // If decoded token or expiration time is not provided or falsy, return true (expired)
    return true;
  }

  // Extract the expiration time from the decoded token
  const expirationTime = decodedToken.exp * 1000;

  // Check if the current time is past the token's expiration time
  return Date.now() >= expirationTime;
};

export default IsTokenExpired;
